import vaReporterPlans from './plans/store';
import vaReporterReports from './reports/store';
import vaReporterSources from './sources/store';

export default {
  vaReporterPlans,
  vaReporterReports,
  vaReporterSources,
};
